/* global axios */
import ApiClient from './ApiClient';

class TalkviaDeliveryRoutesAPI extends ApiClient {
  constructor() {
    super('talkvia_delivery_routes', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { talkvia_delivery_route: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { talkvia_delivery_route: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  generate(id, data = {}) {
    return axios.post(`${this.url}/${id}/generate`, {
      talkvia_delivery_route: data,
    });
  }

  getSources() {
    return axios.get(`${this.url}/sources`);
  }
}

export default new TalkviaDeliveryRoutesAPI();
